import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { TwUnidadInspeccionViewModelExtended } from '../../unidad-inspeccion-datosbasicos.types';

@Component({
    selector: 'app-unidad-inspeccion-header',
    templateUrl: './unidad-inspeccion-header.component.html',
    styleUrls: ['./unidad-inspeccion-header.component.scss'],
})
export class UnidadInspeccionHeaderComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() formGroup: FormGroup;
    @Input() unidadInspeccion: TwUnidadInspeccionViewModelExtended;

    isCollapsedCabecera = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.unidadInspeccion?.currentValue) {
            this.updateForm();
        }
    }

    /**
     * This functions sets the values in the unidadInspeccion (@Input) into the form.
     */
    private updateForm(): void {
        this.formGroup.patchValue({
            Campania: this.unidadInspeccion?.FirstRecinto?.Campania || null,
            Periodo: this.unidadInspeccion?.FirstRecinto?.Periodo || null,
            DescripcionComunidad: this.unidadInspeccion?.FirstRecinto?.DescripcionComunidad || null,
            EntidadAuditora: this.unidadInspeccion?.FirstRecinto?.EntidadAuditora || null,
            TipoRecinto: this.unidadInspeccion?.FirstRecinto?.TipoRecinto || null,
            Operador: this.unidadInspeccion?.FirstRecinto?.OperadorRazonSocial,
        });

        this.form = this.formGroup; // componentBase uses this.form
    }
}
